/** Get Summary Dashboard data */
export const ADD_FORM_API_SUCCESS = "ADD_FORM_API_SUCCESS";
export const ADD_FORM_API_FAIL = "ADD_FORM_API_FAIL";
export const GET_ADD_FORM_DATA = "GET_ADD_FORM_DATA";
